export * from './attachment-input.component'